export const VALIDATION_TEXTS = {
  REQUIRED: "This field is required.",
};